
import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Image } from '../services/shared/shared-interface';
import { CommonErrorService } from '../components/common-error';
import { expAppConstants, AppConstants } from '../constants/portal-constants';
import { ApplicationPath, ErrorMessage } from '../services/shared/shared-enums';
import { SharedUtilService } from '../services/shared/shared-util.service';
import { SharedService } from '../services/shared/shared.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class LocationAccessGuard implements CanActivate 
{
	constructor(private sharedService: SharedService,
		private router: Router,
        private errorService: CommonErrorService,
		private sharedUtilService: SharedUtilService,
		private localStorageService: LocalStorageService,
		@Inject(expAppConstants) readonly appConstantsRef: AppConstants) 
	{
		
	}
	
	async canActivate():  Promise<boolean | UrlTree>
	{
		const isTmhCustomerSupportRole = this.localStorageService.getCustomerToDashboard();
		if(this.localStorageService.getTmhCorporateAdminDetails() === null || isTmhCustomerSupportRole)
		{
			return new Promise((resolve) =>
			{
				this.sharedService.getLoggedInUseLocationsIdsObs().subscribe((locationId: string[]) => 
				{
					if (locationId && locationId.length > 0) 
					{
						resolve(true);

					}
					else
					{
						this.triggerErrorService(ErrorMessage.noLocations, 100, '');
						this.sharedService.navigateMethod(this.router, ApplicationPath.unAuthError);
						resolve(false);
					}
				}
				);
			});
		}
		return false;
	}
	
	private triggerErrorService(status: string, statusCode: number, id:string) 
	{
		const image: Image = this.sharedUtilService.setImageBasedOnStatusCode(statusCode);
		this.errorService.updateState({ messages: [{ message: status }, { message: this.sharedService.updateGetAdminEmail(this.sharedUtilService.getMessage()), cssClass: 'error-contact-section' }], statusCode: statusCode, id: id, image: image });
	}
}
